// TODO: This should live in the appropriate shared library once one is created.

/* spell-checker: disable */
export var ApplicationTypeId = /*#__PURE__*/function (ApplicationTypeId) {
  ApplicationTypeId["ARGROSSINCOMETAX"] = "ARGROSSINCOMETAX";
  ApplicationTypeId["ARINVESTMENTACCOUNTS"] = "ARINVESTMENTACCOUNTS";
  ApplicationTypeId["ARTAXAMNESTY"] = "ARTAXAMNESTY";
  ApplicationTypeId["AUACTIVITYSTATEMENTS"] = "AUACTIVITYSTATEMENTS";
  ApplicationTypeId["AUTAX"] = "AUTAX";
  ApplicationTypeId["CATAX"] = "CATAX";
  ApplicationTypeId["CHECKPOINTENGAGE"] = "CHECKPOINTENGAGE";
  ApplicationTypeId["GPTP"] = "GPTP";
  ApplicationTypeId["NONE"] = "NONE";
  ApplicationTypeId["ONVIOACCOUNTS"] = "ONVIOACCOUNTS";
  ApplicationTypeId["TRIALBALANCE"] = "TRIALBALANCE";
  ApplicationTypeId["UKCOMPANYFORMATIONS"] = "UKCOMPANYFORMATIONS";
  ApplicationTypeId["UKSECRETARIAL"] = "UKSECRETARIAL";
  ApplicationTypeId["UKTAX"] = "UKTAX";
  ApplicationTypeId["UKVAT"] = "UKVAT";
  ApplicationTypeId["ULTRATAX"] = "ULTRATAX";
  ApplicationTypeId["USADVISORYTOOLS"] = "USADVISORYTOOLS";
  ApplicationTypeId["USFIXEDASSETS"] = "USFIXEDASSETS";
  ApplicationTypeId["USTAX"] = "USTAX";
  ApplicationTypeId["WORKPAPERS"] = "WORKPAPERS";
  return ApplicationTypeId;
}({});
